export default "__VITE_ASSET__48ee8cc1__"